import Input from "../../../../../shared/components/UI/Input";
import { FieldErrors, UseFormRegister } from "react-hook-form";

interface Props {
  label: string;
  inputName: string;
  register: UseFormRegister<any>;
  errors: FieldErrors;
}

export default function LabeledInput({
  label,
  inputName,
  register,
  errors,
}: Props) {
  const hasError = !!errors[inputName];
  return (
    <div className="cabinet_profileeditmodal-right-content-box">
      <div className="cabinet_profileeditmodal-right-content-box-wrapper">
        <Input
          type="text"
          grayStyle
          placeholder=""
          className={`cabinet_profileeditmodal-right-content-box-wrapper-input ${
            hasError ? "input-error" : ""
          }`}
          {...register(inputName)}
        />
        <label className="cabinet_profileeditmodal-right-content-box-wrapper-label">
          {label}
        </label>
      </div>
    </div>
  );
}
